import { cn } from "@/lib/utils";

const STAGES = [["REQUEST", "Request"], ["ASSIGNED", "Assigned"], ["SOURCING", "Sourcing"], ["OFFERS", "Offers"], ["CLIENT_DECISION", "Client decision"], ["READY_TO_BOOK", "Ready to book"]];

// Reference "intake lifecycle pipeline": real per-status counts over the whole authorised set; click a stage to filter.
export function PipelineStrip({ byStatus, active, onSelect, testId = "enquiries-pipeline" }) {
  if (!byStatus) return null;
  const total = STAGES.reduce((n, [s]) => n + (byStatus[s] || 0), 0);
  return (
    <section data-testid={testId} className="rounded-[10px] border border-jigsaw-border bg-white px-4 py-3">
      <div className="flex items-baseline justify-between gap-3">
        <p className="text-[11px] font-semibold uppercase tracking-[0.06em] text-jigsaw-muted">Intake lifecycle pipeline <span className="font-normal normal-case tracking-normal">· click a stage to filter</span></p>
        <p className="font-mono-ref text-[12px] text-jigsaw-muted">Open queue: {total}</p>
      </div>
      <ol className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6">
        {STAGES.map(([s, label], i) => {
          const isActive = active === s;
          return (
            <li key={s}>
              <button type="button" data-testid={`${testId}-${s.toLowerCase()}`} aria-pressed={isActive} onClick={() => onSelect(isActive ? "ALL" : s)}
                className={cn("flex w-full flex-col rounded-[8px] border px-3 py-2 text-left transition-colors", isActive ? "border-[#BFD3F5] bg-[#E8F0FC]" : "border-jigsaw-border bg-white hover:bg-jigsaw-bg")}>
                <span className="flex items-center justify-between font-mono-ref text-[11px] text-jigsaw-muted"><span>0{i + 1}</span><span className={cn("rounded-full px-1.5 py-0.5 text-[11px] font-semibold", isActive ? "bg-[#1F4E9C] text-white" : "bg-jigsaw-bg text-jigsaw-navy")}>{byStatus[s] || 0}</span></span>
                <span className={cn("mt-1 text-[13px] font-semibold", isActive ? "text-[#1F4E9C]" : "text-jigsaw-navy")}>{label}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
